<template>
    <b-popover
        custom-class="popover-card"
        :target="target"
        placement="bottom"
        triggers="hover"
        @show="onShow"
        @hide="onHide"
        :offset="150"
    >
        <b-skeleton-img
            v-if="!landingPage.exists"
            no-aspect
            height="160px"
        />

        <b-img
            v-else
            :src="cover"
            class="cover-img"
        />
        <div class="d-flex align-items-center justify-content-center">
            <div
                class="storage-image-wrapper d-flex align-items-center justify-content-center"
                v-if="landingPage.avatar"
            >
                <b-img
                    :src="landingPage.avatar.publicStorageUrl"
                    class="avatar-img"
                />
            </div>

            <div
                v-else
                class="avatar-wrapper"
            >
                <div class="avatar alert-primary">
                    {{ `${landingPage.firstName} ${landingPage.lastName}` | initials(2) }}
                </div>
            </div>
        </div>
        <contact-details :landing-page="landingPage" />
    </b-popover>
</template>

<script>
    import './PopoverCard.scss';
    import {HOME_IMAGES} from "../../../helpers/images";
    import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";
    import StorageImage from "../../StorageImage/StorageImage";
    import ContactDetails from "../ContactDetails/ContactDetails";

    export default {
        name: "PopoverCard",
        components: {
            ContactDetails,
            StorageImage
        },
        props: {
            landingPage: {
                type: LandingPageAppResource,
                required: true
            },
            target: {
                type: String,
                required: true
            },
        },
        computed: {
            cover() {
                return (this.landingPage.home.cover || {}).publicStorageUrl || HOME_IMAGES.POPOVER_CARD_COVER;
            },
            afterElement() {
                if (document.getElementById(this.target).getElementsByClassName('after').length) {
                    return document.getElementById(this.target).getElementsByClassName('after')[0];
                }
                return null;
            }
        },
        methods: {
            onShow() {
                if (this.afterElement) {
                    this.afterElement.classList.add('d-block');
                }
            },
            onHide() {
                if (this.afterElement) {
                    this.afterElement.classList.remove('d-block');
                }
            },
        }
    };
</script>
